package one.healthium.health_tools.ui.models

import androidx.compose.runtime.Immutable

@Immutable
data class DailyStepsUiModel(
    val steps: Long,
    val goal: Long,
)